import { Injectable } from "@angular/core";
import { PessoaFisicaJuridicaDTO } from "app/model/dtos/grl/pessoa-fisica-juridica.dto";
import { Equal, HttpFilter, HttpGet, HttpResponse, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { environmentv3 } from "src/environments/environmentv3";

@Injectable()
export class PessoaFisicaJuridicaController {

    getPessoaByCPFCNPJ(nrCpfCnpj: string): Promise<PessoaFisicaJuridicaDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoafisicajuridica',
                    environment: environmentv3,
                    filter: new HttpFilter([
                        new Equal('nrCpfCnpj', nrCpfCnpj)
                    ]),
                }),
            }),
            new HttpResponse(new PessoaFisicaJuridicaDTO())
        );
        return request.call();
    }
}